/**
 * Adaptation d'un jeu de tâches partiel (une page de liste, un résultat filtré) avant
 * `buildRows` de `@exiplan/gantt`.
 *
 * `buildRows` ne descend que depuis la racine : une tâche dont le parent est absent du
 * tableau n'y est atteignable par aucun chemin et disparaîtrait silencieusement — la même
 * perte de visibilité que le lot 0 vient de fermer côté Gantt. On la rend donc à la racine.
 *
 * Fonction pure : ni copie profonde, ni mutation de l'entrée.
 */
export function graftOrphans(tasks) {
  const present = new Set(tasks.map((task) => task.id));
  return tasks.map((task) =>
    task.parentId && !present.has(task.parentId) ? { ...task, parentId: null } : task,
  );
}
